import { createSelector } from '@reduxjs/toolkit';
import { ContractType } from 'client/voladeum/contract-types/types';
import { RootState } from 'store';

const contractTypesSlice = (state: RootState) => state.contract_types;

export const selectContractTypes = createSelector(
  [contractTypesSlice],
  (state): ContractType[] => state
);
